import React from "react";
import LandingPage from "./landingPage";
import ContactUs from "./contactUs";
import Products from "./products";

export default function PageSelection(props) {
    const { selection, setSelection } = props

    if (selection === "products") {
        return <Products setSelection={setSelection} />
    } else if (selection === "contactUs") {
        return <ContactUs setSelection={setSelection} />;
    } else {
        return <LandingPage setSelection={setSelection} />;
    }
}